import { Form } from '@unform/web';
import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import CustomButton from '../../components/Form/Button';
import Input from '../../components/Form/Input';

import { register } from '../../services/Auth';

import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { MdPersonAdd } from "react-icons/md";
import logo from "../../assets/img/logo.png";
import Copyright from "../../components/Copyright";
import {
  SignUpWrapper,
  LoginCard,
  CardHeader,
  CardBody,
  FooterText,
  CopyrightContainer,
  FormWrapper,
  StyledFormWrapper
} from "./styles";

function SignUp() {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const history = useHistory();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  async function handleRegister(data) {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required("O nome é obrigatório"),
        email: Yup.string()
            .email("Insira um e-mail válido")
            .required("O e-mail é obrigatório"),
        password: Yup.string().required("A senha é obrigatória")
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      const formData = new FormData();
      formData.append('name', data.name);
      formData.append('username', data.email);
      formData.append('password', data.password);
      const response = await register(formData);

      if (response && response.status === 200) {
        localStorage.setItem('@name', response.data.name);
        localStorage.setItem('userKey', data.email);
        localStorage.setItem('@user_token', response.data.token);
        toast.success("Cadastrado realizado com sucesso!");
        history.push('/dashboard');
      } else {
        toast.error("Erro ao salvar usuário!");
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      toast.error("Erro ao salvar usuário!");
      setLoading(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  return (
      <>
        <SignUpWrapper>
          <div className="col-12 d-flex flex-column justify-content-center logo-sm pt-2 pt-md-4" style={{ position: 'relative', zIndex: 1, marginBottom: '1.5rem' }}>
            <Link to={"/"}>
              <img
                alt={"Logo do sistema"}
                src={logo}
                style={{
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  maxWidth: '100%',
                  height: 'auto',
                  width: '120px'
                }}
                className="d-md-none"
              />
              <img
                alt={"Logo do sistema"}
                src={logo}
                style={{
                  display: 'none',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  maxWidth: '100%',
                  height: 'auto',
                  width: '160px'
                }}
                className="d-none d-md-block"
              />
            </Link>
          </div>
          
          <LoginCard>
            <CardBody>
              <CardHeader>
                <h1>
                  <i className="fas fa-user-plus"/> Crie a sua conta
                </h1>
              </CardHeader>
              
              <StyledFormWrapper>
                <Form ref={formRef} onSubmit={handleRegister}>
                  <div className="row mb-4">
                    <div className="col-12">
                      <Input
                        type="text"
                        name="name"
                        label={"Informe seu nome"}
                      />
                    </div>
                  </div>
                  
                  <div className="row mb-4">
                    <div className="col-12">
                      <Input
                        type="text"
                        name="email"
                        label={"Informe seu e-mail"}
                      />
                    </div>
                  </div>
                  
                  <div className="row mb-4">
                    <div className="col-12">
                      <Input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        label={"Informe sua senha"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                                style={{ color: '#ffffff' }}
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                  
                  <div className="row mb-4">
                    <div className="col-12">
                      <CustomButton
                        startIcon={<MdPersonAdd/>}
                        className="btn btn-primary text-capitalize font-weight-bold mobile-button"
                        loading={loading}
                        type="submit"
                        style={{
                          background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
                          border: 'none',
                          color: '#ffffff',
                          borderRadius: '8px',
                          fontWeight: 600,
                          width: '100%',
                          boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => {
                          if (!loading) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                        }}
                      >
                        Criar
                      </CustomButton>
                    </div>
                  </div>
                  
                  <FooterText>
                    Já tem uma conta?
                    <span
                      onClick={() => {
                        window.location = '/login';
                      }}
                    >
                      {' '}Entre agora
                    </span>
                  </FooterText>
                </Form>
              </StyledFormWrapper>
            </CardBody>
          </LoginCard>
          
          <CopyrightContainer>
            <Copyright/>
          </CopyrightContainer>
        </SignUpWrapper>
      </>
  );
}

export default SignUp;
